export default {
  title: {
    add: 'add',
    editor: 'edit'
  },
  label: {
    createAcct: 'editor',
    createTime: 'Creation time',
    id: 'Primary key id',
    ipList: 'ip address',
    merchantNo: 'merchantNo',
    updateAcct: 'updater',
    updateTime: 'update time',
    action: 'operate',
    operator: 'Operator',
  },
  rules: {
    ipList: {
      required: 'Please enter the ip address',
      isip: 'IP address format is incorrect'
    },
    merchantNo: {
      required: 'Please enter merchantNo'
    }
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/merchantip.js